
import React from 'react';
import { Button } from "@/components/ui/button";
import { DialogClose } from "@/components/ui/dialog";
import { CheckCircle2 } from 'lucide-react';

const ContactSuccess: React.FC = () => {
  return (
    <div className="py-6 text-center">
      <div className="mx-auto w-12 h-12 flex items-center justify-center rounded-full bg-green-100 mb-4">
        <CheckCircle2 className="h-6 w-6 text-green-600" />
      </div>
      <h2 className="text-xl font-semibold mb-2">Thank You!</h2>
      <p className="text-gray-600 mb-6">
        We've received your request and will get back to you shortly.
      </p>
      <DialogClose asChild>
        <Button className="w-full">Close</Button>
      </DialogClose>
    </div>
  );
};

export default ContactSuccess;
